import { defineStore } from "pinia"
import { forEach } from "lodash-es"
import { UPDATE_DATA_THRESHOLD } from "@/constants"
import { addOrUpdate, paginatedFetch } from "@/libraries/helpers"

export default defineStore("log", {
  state: () => ({
    all: [],
  }),
  getters: {},
  actions: {
    fetchAll({ persist = false } = {}) {
      paginatedFetch({
        url: "/v1/logs",
        persist,
        callback: data => forEach(data || [], v => addOrUpdate(this.all, v, ["id"])),
        runCallbackCondition: data => this.all.length === 0 || data.length > UPDATE_DATA_THRESHOLD,
      })
    },
  },
})
